<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.addToRM}}</h3>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-xs-12">
			<h5>{{LOCALIZATION.rmAddAsManagedRecords}}</h5>
			<hr>
			<h6 class="help-block">{{LOCALIZATION.rmFilterByCategory}}</h6>
		</div>
	</div>
	<div class="row well-sm">
		<div class="col-xs-12">
			<div *ngFor="let field of formFields" class="row" style="padding-bottom:8px;">
				<div class="col-sm-4 col-xs-4 form-inline">
					<span style="background-color:transparent;line-height:40px;width:85%;"><b>{{field.label}}</b></span>
				</div>
				<div class="col-sm-8 col-xs-8">
					<div *ngFor="let metadata of templateMetadata[field.name]; let i = index;">				
						<select class="form-control" style="display:inline-block;" 
								[(ngModel)]="templateMetadata[field.name][i]" 
								id="{{field.name}}" name="{{field.name}}" 
								title="{{field.placeholder}}"
								[attr.aria-label]="field.label"
								(change)="onChangeRMCategory()"
								[required]="field.required" 
								[disabled]="field.readOnly">
								  <option *ngFor="let option of field.allowedValues" [ngValue]="option.value">
								    {{ option.name }}
								  </option>								
						</select>
						<span *ngIf="field.required" class="required">{{LOCALIZATION.required}} </span>
					</div>
				</div>
			</div>
			<!-- // Existing folder select -->
			<div class="row" style="padding-bottom:8px;">
				<div class="col-sm-4 col-xs-4 form-inline">
					<span style="background-color:transparent;line-height:40px;width:85%;"><b>{{LOCALIZATION.folderRM}}</b></span>
				</div>
				<div class="col-sm-8 col-xs-8">
					<select class="form-control" style="display:inline-block;" 
							[(ngModel)]="input.rm_folder_select" 
							id="rm_folder_select" name="rm_folder_select" 
							title="{{LOCALIZATION.folderRM}}"
							[attr.aria-label]="LOCALIZATION.folderRM">
							  <option *ngFor="let option of rm_folders" [ngValue]="option.id">
							    {{ option.name }}
							  </option>								
					</select>
				</div>
			</div>									
			<!-- // New folder input -->
			<!--
			<div class="row" style="padding-bottom:8px;">
				<div class="col-sm-4 col-xs-4 form-inline">
					<span style="background-color:transparent;line-height:40px;width:85%;"><b>{{LOCALIZATION.folderRM}} <span class="font-size:0.90em;">(create new)</span></b></span>
				</div>
				<div class="col-sm-8 col-xs-8 form-inline">
					<input type="text" class="item-input"
						ng-model='input.rm_folder_input' id="rm_folder_input" name="rm_folder_input" ng-disabled='input.rm_folder_select'
						placeholder="Enter a new folder name">
				</div>
			</div>	
			-->								
		</div>
	</div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="submit()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.fileAsRMRecords}}
    </button>
</div>
